import { render, staticRenderFns } from "./AddDentist.vue?vue&type=template&id=412e18e6&scoped=true"
import script from "./AddDentist.vue?vue&type=script&lang=js"
export * from "./AddDentist.vue?vue&type=script&lang=js"
import style0 from "./AddDentist.vue?vue&type=style&index=0&id=412e18e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412e18e6",
  null
  
)

export default component.exports